import { render, staticRenderFns } from "./DeviceModulePanel.vue?vue&type=template&id=5139f987"
import script from "./DeviceModulePanel.vue?vue&type=script&lang=js"
export * from "./DeviceModulePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports